import { Children, PropsWithChildren, ReactElement } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';

import { useToggleMenu, useVariants } from 'hooks/toggleMenu';

interface IProps {
  Button: ReactElement;
  minWidth?: number;
  isSubMenu?: boolean;
  listIndex?: number;
}

export const Menu = ({
  Button,
  minWidth = 0,
  isSubMenu = false,
  children,
  listIndex,
}: PropsWithChildren<IProps>) => {
  const { isMenuVisible, showMenu, hideMenu, ref } = useToggleMenu();
  const { variants } = useVariants();

  return (
    <div
      className="relative"
      onClick={e => e.preventDefault()}
      onMouseLeave={hideMenu}
    >
      <button className="block" onClick={showMenu} onMouseEnter={showMenu}>
        {Button}
      </button>

      <motion.div
        className={classNames('absolute z-10', {
          'bottom-0 right-0 pt-3': !isSubMenu,
          'top-0': isSubMenu,
        })}
        style={
          isSubMenu
            ? listIndex
              ? (window.matchMedia('(min-width: 1024px)').matches &&
                  listIndex % 4 === 0) ||
                (window.matchMedia('(min-width: 768px)').matches &&
                  !window.matchMedia('(min-width: 1024px)').matches &&
                  listIndex % 3 === 0) ||
                (!window.matchMedia('(min-width: 768px)').matches &&
                  listIndex % 2 === 0)
                ? { right: minWidth + 4 }
                : { left: minWidth + 4 }
              : { left: minWidth + 4 }
            : undefined
        }
        variants={!isSubMenu ? variants : undefined}
        ref={ref}
        initial="hidden"
        animate="show"
        onMouseEnter={showMenu}
      >
        {isMenuVisible && (
          <motion.div>
            <div className="rounded-md bg-white text-sm text-mineShaftGrey shadow-md dark:bg-darkMineShaftGrey dark:text-white">
              {Children.map(children, (child, index) => {
                if (!child) {
                  return null;
                }

                return (
                  <div
                    className={classNames(
                      'min-h-[42px] w-full opacity-50 transition-opacity hover:opacity-100',
                      {
                        'border-t border-black/10 dark:border-white/10':
                          index > 0,
                      },
                    )}
                    style={{ minWidth }}
                  >
                    {child}
                  </div>
                );
              })}
            </div>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};
